import React, {useEffect, useState} from "react";
import profile_logo from "../assets/profile-user-icon.svg";
import {Link, useNavigate} from "react-router-dom";
import ColourBar from "../components/ColourBar";
import ccmi_logo from "../assets/ccmi_logo.webp";
import ccmi_logo_mobile from "../assets/Clutterbuck Logo mark.png"
import profile_api from "../api/protected/profile";
import notifications_api from "../api/protected/notifications"
import burger_close from "../assets/mobile-burger-close.svg";
import burger_open from "../assets/mobile-burger-menu.svg";
import expandable_close from "../assets/mobile-menu-expandable-close.svg";
import expandable_open from "../assets/mobile-menu-expandable-open.svg";
import auth from "../api/auth";


const MainHeader = () => {
    const navigate = useNavigate();
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [profilePicture, setProfilePicture] = useState(profile_logo);
    const [session, setSession] = useState(false)

    const [organisationsNotificationCount, setOrganisationsNotificationCount] = useState(0)
    const [teamsNotificationCount, setTeamsNotificationCount] = useState(0)
    const [surveysNotificationCount, setSurveysNotificationCount] = useState(0)
    const [reportsNotificationCount, setReportsNotificationCount] = useState(0)
    const [generalNotificationCount, setGeneralNotificationCount] = useState(0)

    const [burgerMenuOpen, setBurgerMenuOpen] = useState(false)
    const [perillMenuOpen, setPerillMenuOpen] = useState(false)
    const [ccmiMenuOpen, setCcmiMenuOpen] = useState(false)

    const togglePerillMenu = (ev) => {
        if (!ev) return;
        setCcmiMenuOpen(false)
        setPerillMenuOpen(!perillMenuOpen)
    }
    const toggleCCMIMenu = (ev) => {
        if(!ev) return;
        setPerillMenuOpen(false)
        setCcmiMenuOpen(!ccmiMenuOpen)
    }
    const menuNavigate = (path) => {
        navigate(path);
        setBurgerMenuOpen(false)
    }
    const handleItemClick =(ev) => {
        const id = ev.currentTarget.id;
        if (!id) return;

        switch (ev.target.id) {
            case "PERILL":
                navigate("/what-is-the-perill-model")
                break;
            case "HIW":
                navigate("/perill-how-it-works")
                break;
            case "Resources":
                navigate("/perill-resources")
                break;
            case "About":
                navigate("/about-ccmi")
                break;
            case "Training":
                navigate("/team-coaching")
                break;
            case "aBooks":
                console.log("books")
                window.open("https://clutterbuck-cmi.com/books/?filter_terms=team-coaching", "_blank", "noopener,noreferrer");
                break;
        }
        setPerillMenuOpen(false);
    }

    function handleLogout() {
        window.location.assign("/logout")
    }

    function handleSettingsClick() {
        setShowProfileMenu(false);
        navigate("/settings")
    }

    function handleFAQsClick() {
        setShowProfileMenu(false);
        window.open("/faq", "_blank", "noopener,noreferrer");
    }

    const handleNotificationsClick = (ev) => {
        if(!ev) return;
        setShowProfileMenu(false)
        navigate("/notifications")
    }

    const handleLinkClick = (url) => {
        auth.protectedNavigate(url, "/logout")
    }

    const GetProfilePicture = () => {
        let response = profile_api.getProfilePicture();
        response.then(
            response => {
                if (response.data.image !== "") {
                    setProfilePicture(response.data.image);
                }
            }
        ).catch(err => {
            console.log(err);
        })
    }

    const GetNotificationIndicators = () => {
        let response = notifications_api.getNotificationCount();
        response.then(response => {
            setOrganisationsNotificationCount(response.data.organisations)
            setTeamsNotificationCount(response.data.teams)
            setSurveysNotificationCount(response.data.surveys)
            setReportsNotificationCount(response.data.reports)
            setGeneralNotificationCount(response.data.general)
        }).catch()
    }

    useEffect(() => {
        GetProfilePicture();
        GetNotificationIndicators();
    }, [])

    return (
        <>
            <div className="home-header-container bordered">
                <ColourBar classnames="hide-mobile"/>
                <div className="home-header-contents hide-mobile">
                    <Link to="/" className="home-header-logo-container">
                        <img src={ccmi_logo} alt="CCMI" className="dashboard-logo"/>
                        <img src={ccmi_logo_mobile} alt="CCMI" className="dashboard-logo-mobile"/>
                    </Link>
                    <div className="home-header-navbar no-select">
                        <div className="home-header-navbar-item">
                            <div className="home-header-navbar-item-title"
                                 onClick={() => handleLinkClick("/dashboard")}>
                                Dashboard
                            </div>
                        </div>
                        <div className="home-header-navbar-item">
                            {organisationsNotificationCount ? <div
                                className="header-profile-notification-dot organisations">{organisationsNotificationCount}</div> : null}
                            <div className="home-header-navbar-item-title"
                                 onClick={() => handleLinkClick("/organisations")}>
                                Organisations
                            </div>
                        </div>
                        <div className="home-header-navbar-item">
                            {teamsNotificationCount ? <div
                                className="header-profile-notification-dot teams">{teamsNotificationCount}</div> : null}
                            <div className="home-header-navbar-item-title" onClick={() => handleLinkClick("/teams")}>
                                Teams
                            </div>
                        </div>
                        <div className="home-header-navbar-item">
                            {surveysNotificationCount ? <div
                                className="header-profile-notification-dot surveys">{surveysNotificationCount}</div> : null}
                            <div className="home-header-navbar-item-title" onClick={() => handleLinkClick("/surveys")}>
                                Surveys
                            </div>
                        </div>
                        <div className="home-header-navbar-item">
                            {reportsNotificationCount ? <div
                                className="header-profile-notification-dot reports">{reportsNotificationCount}</div> : null}
                            <div className="home-header-navbar-item-title" onClick={() => handleLinkClick("/reports")}>
                                Reports
                            </div>
                        </div>
                        <div className="home-header-navbar-item header-profile-container">
                            {generalNotificationCount ? <div
                                className="header-profile-notification-dot general">{generalNotificationCount}</div> : null}
                            <div className={profilePicture !== profile_logo ? "header-profile-image-circle" :
                                "header-profile-image-circle default"}
                                 onClick={() => setShowProfileMenu(!showProfileMenu)}>
                                <img src={profilePicture} alt="Profile" className="link"/>
                            </div>
                            {showProfileMenu ?
                                <>
                                    <div className="transparent-page-mask" onClick={() => setShowProfileMenu(false)}/>
                                    <div className="home-header-navbar-dropwdown-menu main-header">
                                        <div className="home-header-navbar-dropwdown-menu-triangle-outer">
                                            <div className="home-header-navbar-dropwdown-menu-triangle-inner"/>
                                        </div>
                                        <div className="home-header-navbar-dropdown-item"
                                             onClick={handleNotificationsClick}>Notifications
                                        </div>
                                        <div className="home-header-navbar-dropdown-item" onClick={handleFAQsClick}>FAQs & Guides
                                        </div>
                                        <div className="home-header-navbar-dropdown-item"
                                             onClick={handleSettingsClick}>Settings
                                        </div>
                                        <div className="home-header-navbar-dropdown-item" onClick={handleLogout}>Logout
                                        </div>
                                    </div>
                                </>
                                : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className={`home-header-container-mobile ${burgerMenuOpen ? "burger" : ""}`}>
                <ColourBar/>
                <div className="home-header-container-mobile-body">
                    <Link to="/" className="home-header-logo-container-mobile">
                        <img src={ccmi_logo_mobile} alt="CCMI"/>
                    </Link>
                    <img src={burgerMenuOpen ? burger_close : burger_open}
                         alt={burgerMenuOpen ? "Close menu" : "Open menu"}
                         onClick={() => setBurgerMenuOpen(!burgerMenuOpen)}
                    />
                </div>
                {burgerMenuOpen ?
                    <div className="burger-menu-body">
                        <>
                            <div className="perill-menu-divider-mobile no-top"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => handleLinkClick("/dashboard")}>
                                    Dashboard
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => handleLinkClick("/organisations")}>
                                    Organisations
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => handleLinkClick("/teams")}>
                                    Teams
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => handleLinkClick("/surveys")}>
                                    Surveys
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => handleLinkClick("/reports")}>
                                    Reports
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-expandable-mobile">
                                <div className="perill-menu-expandable-item main"
                                     onClick={() => {
                                         auth.protectedNavigate("/settings", "/login")
                                         setBurgerMenuOpen(false);
                                     }}>
                                    Settings
                                </div>
                            </div>
                            <div className="perill-menu-divider-mobile"/>
                            <div className="perill-menu-sign-in-button bold" onClick={handleLogout}>
                                LOGOUT
                            </div>
                            <div className="perill-menu-privacy-policy-link bold"
                                 onClick={() => menuNavigate("/privacy")}>
                                PRIVACY POLICY
                            </div>
                        </>
                    </div> : null
                }
            </div>
        </>
    )
}

export default MainHeader